export default "__VITE_ASSET__DjSfFdAA__"